import { z } from "zod";

/** Administration humaine : aucune permission implicite par adresse courriel. */
export const ClientCompanyAccessParamsSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
});
export const GrantClientCompanyAccessSchema = z
  .object({
    can_upload: z.boolean().default(false),
  })
  .strict();
export const FileClientVisibilitySchema = z
  .object({
    visible: z.boolean(),
  })
  .strict();
